export const ALERT_TYPES = {
  MARGIN_EROSION: 'MARGIN_EROSION',
  COST_INCREASE_NO_PRICE_CHANGE: 'COST_INCREASE_NO_PRICE_CHANGE',
  LOW_MARGIN: 'LOW_MARGIN',
  POSSIBLE_STOCKOUT: 'POSSIBLE_STOCKOUT',
  INVENTORY_VARIANCE: 'INVENTORY_VARIANCE',
  VENDOR_COST_SURGE: 'VENDOR_COST_SURGE',
  PRICE_STAGNATION: 'PRICE_STAGNATION',
} as const;

export const ALERT_SEVERITY = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
} as const;

export const ALERT_STATUS = {
  NEW: 'NEW',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  RESOLVED: 'RESOLVED',
  DISMISSED: 'DISMISSED',
} as const;

export const ALERT_TYPE_LABELS: Record<string, string> = {
  MARGIN_EROSION: 'Margin Erosion',
  COST_INCREASE_NO_PRICE_CHANGE: 'Cost Increase — No Price Change',
  LOW_MARGIN: 'Below Target Margin',
  POSSIBLE_STOCKOUT: 'Possible Stockout',
  INVENTORY_VARIANCE: 'Inventory Variance',
  VENDOR_COST_SURGE: 'Vendor Cost Surge',
  PRICE_STAGNATION: 'Price Stagnation',
};

